import { render, staticRenderFns } from "./zufang.vue?vue&type=template&id=4914c96e&scoped=true&"
import script from "./zufang.vue?vue&type=script&lang=js&"
export * from "./zufang.vue?vue&type=script&lang=js&"
import style0 from "./zufang.vue?vue&type=style&index=0&id=4914c96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4914c96e",
  null
  
)

export default component.exports